import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  pageHeading: {
    id: "get-started: heading",
    defaultMessage: "Get started",
  },
  pageSubtitle: {
    id: "get-started: subtitle",
    defaultMessage: "Apply for funding and track your application progress.",
  },
  cardTitle: {
    id: "get-started: application card title",
    defaultMessage: "Application",
  },
  tagActionRequired: {
    id: "get-started: application card tag action required",
    defaultMessage: "Action required",
  },
  tagInReview: {
    id: "get-started: application card tag in review",
    defaultMessage: "In review",
  },
  footerActionRequired: {
    id: "get-started: application card footer action required",
    defaultMessage: "Complete these tasks to continue your review.",
  },
  footerInReview: {
    id: "get-started: application card footer in review",
    defaultMessage: "We'll email you as soon as your review is complete.",
  },
  footerNoApplication: {
    id: "get-started: application card footer no application",
    defaultMessage: "Apply for funding to power your next stage of growth.",
  },
  applyCta: {
    id: "get-started: application card apply cta",
    defaultMessage: "Apply for funding",
  },
});
